import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIsrael = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_336)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.5184 9.39131H13.5061L12 6.78262L10.4939 9.39131H7.48157L8.98785 12L7.48157 14.6087H10.4939L12 17.2174L13.5061 14.6087H16.5184L15.0121 12L16.5184 9.39131ZM13.8504 12L12.9253 13.6026H11.0749L10.1496 12L11.0748 10.3974H12.9252L13.8504 12ZM12 8.79483L12.3443 9.39126H11.6557L12 8.79483ZM9.22433 10.3974H9.91302L9.56868 10.9939L9.22433 10.3974ZM9.22433 13.6026L9.56872 13.0061L9.91307 13.6026H9.22433ZM12 15.2051L11.6557 14.6087H12.3443L12 15.2051ZM14.7756 13.6026H14.087L14.4313 13.0061L14.7756 13.6026ZM14.087 10.3974H14.7756L14.4313 10.9939L14.087 10.3974Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.4698 2.60869H4.53009C3.43495 3.48094 2.49576 4.54041 1.76123 5.73914H22.2387C21.5041 4.54045 20.5649 3.48094 19.4698 2.60869Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.53009 21.3913H19.4698C20.5649 20.5191 21.5041 19.4596 22.2386 18.2609H1.76123C2.49581 19.4595 3.435 20.5191 4.53009 21.3913Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_336",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgIsrael;
